import BaseEvent from './BaseEvent.js';

class LockMeetingEvent extends BaseEvent {
  handle() {
    this.context._api.lockMeeting();
  }
}

export default LockMeetingEvent;
